
import {
  Component,
  Input,
} from '@angular/core';
import { AbstractControl, NgModel } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorsMessages } from '../../model/error-messge.model';

@Component({
    selector: 'app-error-form',
    imports: [TranslateModule],
    template: `
    @if (control && (!control.valid || control.touched || control.dirty)) {
      <span>
        @if (control.errors?.['required']) {
          {{ name | translate }} {{ 'REQUIRED' | translate }} !
        }
        @if (control.errors?.['minlength']) {
          {{ name | translate }} {{ 'REQUIRED_MIN_LENGTH' | translate }}
          {{ minLength }}
        }
        @if (control.errors?.['maxlength']) {
          {{ name | translate }} {{ 'NOT_MORE_THAN' | translate }} {{ maxLength }}
        }
        @if (control.errors?.['min']) {
          {{ name | translate }} {{ 'NOT_LESS_THAN' | translate }} {{ min }}
        }
        @if (control.errors?.['max']) {
          {{ name | translate }} {{ 'NOT_MORE_THAN' | translate }} {{ max }}
        }
        @if (control?.errors?.['email']) {
          {{ 'VALID_EMAIL' | translate }}
        }
      </span>
    }
    `
})
export class ErrorFormComponent {
  formValues: any;

  @Input() minLength: number = 8;
  @Input() maxLength: number = 24;
  @Input() name!: string;
  @Input() max: number = 20;
  @Input() min: number = 1;
  @Input() control!: AbstractControl | NgModel;
  @Input() messages: Partial<ErrorsMessages> = {};

  constructor() {}
}
